// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  startX: __t.f32().name("start_x"),
  startZ: __t.f32().name("start_z"),
  endX: __t.f32().name("end_x"),
  endZ: __t.f32().name("end_z"),
  spawnAt: __t.timestamp().name("spawn_at"),
  durationMicros: __t.i64().name("duration_micros"),
  variant: __t.string(),
  targetPlotId: __t.u64().name("target_plot_id"),
});
